module.exports = __webpack_public_path__ + "94bc1f2fe80bc66e1bd566c56016e412.svg";